var TEMPLATE_URL = require('./credit.card.form.html');

angular.module('ikeweb.user').directive('creditCardForm',

    function() {

        return {
            restrict: 'E',
            replace: true,
            templateUrl: TEMPLATE_URL,
            controller: 'CreditCardController',
            controllerAs: 'ctrl'
        };
    }
);



//////////////////
// WEBPACK FOOTER
// ./src/client/components/user/billing/credit-card-form/credit.card.form.directive.js
// module id = 492
// module chunks = 0